module.exports = {"330781001":"兰江街道","330781002":"云山街道","330781004":"永昌街道","330781005":"赤溪街道","330781006":"女埠街道","330781007":"上华街道","330781102":"游埠镇","330781104":"诸葛镇","330781106":"黄店镇","330781108":"香溪镇","330781109":"马涧镇","330781111":"梅江镇","330781112":"横溪镇","330781200":"灵洞乡","330781203":"水亭畲族乡","330781209":"柏社乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330781.json
// module id = 1002
// module chunks = 0